import { useSelector } from 'react-redux';
import { selectPermissions, selectIsModerator } from './sessionSlice';

/**
 * Доступ к capability текущего пользователя.
 *
 * Гейтим UI через `can(capability)`, а не по имени роли — список прав приходит
 * из /me и остаётся единственным источником правды. `useSelector` здесь
 * намеренно «голый»: entities не должен зависеть от app-слоя (типизация —
 * через сигнатуры селекторов).
 */
export function useCapabilities() {
  const permissions = useSelector(selectPermissions);
  const isModerator = useSelector(selectIsModerator);

  const can = (capability: string): boolean => permissions.includes(capability);

  return { permissions, isModerator, can };
}
